(function ($, abp) {
    function getSeparator(locale, separatorType) {
        const numberWithGroupAndDecimalSeparator = 10000.1;
        return Intl.NumberFormat(locale)
            .formatToParts(numberWithGroupAndDecimalSeparator)
            .find(part => part.type === separatorType)
            .value;
    }

    var numberFormatter = abp.numberFormatter || {};

    numberFormatter.getNumberCulture = function () {
        return numberFormatter.numberCulture;
    };

    numberFormatter.getDecimalDigits = function () {
        return numberFormatter.decimalDigits;
    };

    numberFormatter.getCurrency = function () {
        return numberFormatter.currency;
    };

    numberFormatter.getGroupSeparator = function () {
        return getSeparator(numberFormatter.getNumberCulture(), "group");
    };

    numberFormatter.getDecimalSeparator = function () {
        return getSeparator(numberFormatter.getNumberCulture(), "decimal");
    };

    numberFormatter.formatNumber = function (value, minimumFractionDigits = null, maximumFractionDigits = null) {
        const options = {};
        if (minimumFractionDigits !== null) {
            options.minimumFractionDigits = minimumFractionDigits;
        }
        if (maximumFractionDigits !== null) {
            options.maximumFractionDigits = maximumFractionDigits;
        }

        return new Intl.NumberFormat(abp.numberFormatter.getNumberCulture(), options).format(value);
    };

    numberFormatter.formatCurrency = function (value, includeCurrencyCode = false, minimumFractionDigits = null, maximumFractionDigits = null, currencyCode = null) {
        const nf = abp.numberFormatter;

        const options = {};
        if (minimumFractionDigits !== null) {
            options.minimumFractionDigits = minimumFractionDigits;
        } else {
            options.minimumFractionDigits = numberFormatter.getDecimalDigits();
        }

        if (maximumFractionDigits !== null) {
            options.maximumFractionDigits = maximumFractionDigits;
        } else {
            options.maximumFractionDigits = numberFormatter.getDecimalDigits();
        }

        return (includeCurrencyCode ? (currencyCode ?? nf.getCurrency()) + " " : "") + new Intl.NumberFormat(nf.getNumberCulture(), options).format(value);
    };

    abp.numberFormatter = numberFormatter;
})(jQuery, abp);
